import { Provider } from '@angular/core';
import { LocalStorageService } from '../services/local-storage.service';
import { SessionStorageService } from '../services/session-storage.service';

export function provideSolStorage(storagePrefix: string): Provider[] {
  return [
    {
      provide: LocalStorageService,
      useFactory: () => {
        return new LocalStorageService(storagePrefix);
      },
    },
    {
      provide: SessionStorageService,
      useFactory: () => {
        return new SessionStorageService(storagePrefix);
      },
    },
  ];
}
